// src/realtime/client.js

import { RealtimeClient } from '@theodoreniu/realtime-api-beta';

export class UpdatedRealtimeClient extends RealtimeClient {
    constructor(settings = {}) {
        super(settings);
    }

    updateSession(customConfig = {}) {
        // Enable Available Voices
        if (customConfig.voice) {
            if (!['alloy', 'ash', 'ballad', 'coral', 'echo', 'sage', 'shimmer', 'verse'].includes(customConfig.voice)) {
                throw new Error(`Invalid voice: ${customConfig.voice}`);
            }
        }

        return super.updateSession(customConfig);
    }
}
